import AuditField from "./AuditField";

export default function BlocIdentite({ data }) {
  const isMorale = data.type === "Personne Morale";

  return (
    <section className="space-y-6 bg-white p-6 rounded-xl shadow">
      <h2 className="text-xl font-bold text-gray-800">
        {isMorale ? "Identité de la Société" : "Identité & Coordonnées"}
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {isMorale ? (
          <>
            <AuditField label="Dénomination" value={data.denomination} />
            <AuditField label="Statut juridique" value={data.statutJuridique} />
            <AuditField label="SIRET" value={data.siret} />
            <AuditField label="Secteur d'activité" value={data.secteurActivite} />
            <AuditField label="Date de création" value={data.dateCreation?.slice(0, 10)} />
            <AuditField label="Capital social (€)" value={data.capitalSocial?.toLocaleString()} />
            <AuditField label="Adresse" value={data.adresse} />
            <AuditField label="Code postal" value={data.codePostal} />
            <AuditField label="Ville" value={data.ville} />
            <AuditField label="Pays" value={data.pays} />
            <AuditField label="Email" value={data.email} />
            <AuditField label="Téléphone" value={data.telephone} />
            <AuditField label="Site web" value={data.siteWeb} />
          </>
        ) : (
          <>
            <AuditField label="Civilité" value={data.civilite} />
            <AuditField label="Nom" value={data.nom} />
            <AuditField label="Prénom" value={data.prenom} />
            <AuditField label="Date de naissance" value={data.dateNaissance?.slice(0, 10)} />
            <AuditField label="Lieu de naissance" value={data.lieuNaissance} />
            <AuditField label="Nationalité" value={data.nationalite} />
            <AuditField label="Situation matrimoniale" value={data.situationMatrimoniale} />
            <AuditField label="Régime matrimonial" value={data.regimeMatrimonial} />
            <AuditField label="Enfants" value={data.enfants} />
            <AuditField label="Âges des enfants" value={data.agesEnfants?.join(", ")} />
            <AuditField label="Adresse" value={data.adresse} />
            <AuditField label="Ville" value={data.ville} />
            <AuditField label="Code postal" value={data.codePostal} />
            <AuditField label="Téléphone" value={data.telephone} />
            <AuditField label="Email" value={data.email} />
            <AuditField label="Profil LinkedIn" value={data.linkedin} />
            <AuditField label="Commentaire interne" value={data.commentaire} />
          </>
        )}
      </div>
    </section>
  );
}
